/**
 * EmailJS configuration.
 *
 * EmailJS lets a static, backend-less site send real email straight from the
 * visitor's browser via EmailJS's own servers — no mail client popup, no
 * server of your own required. Free tier: 200 emails/month.
 *
 * Setup (~5 minutes), all done at https://www.emailjs.com :
 *   1. Sign up / log in.
 *   2. Email Services -> Add New Service -> connect inivayal.agritech@gmail.com
 *      (Gmail is a one-click OAuth connection). Copy the "Service ID".
 *   3. Email Templates -> Create New Template. Use these variable names so
 *      they match what Contact.js sends: {{from_name}}, {{from_email}},
 *      {{role}}, {{message}}. Set the template's "To email" field to
 *      inivayal.agritech@gmail.com. Copy the "Template ID".
 *   4. Account -> General -> copy your "Public Key".
 *   5. Paste all three values below.
 *
 * Until all three are filled in, the contact form automatically falls back
 * to opening the visitor's own email app instead (see Contact.js) — so the
 * site keeps working either way.
 */
export const EMAILJS_CONFIG = {
  serviceId: 'service_k81lnw7',
  templateId: 'template_2vodjv8',
  publicKey: 'dtBeMsNon-MCjrM_y',
};

export function isEmailJsConfigured() {
  const { serviceId, templateId, publicKey } = EMAILJS_CONFIG;
  return (
    serviceId !== 'YOUR_SERVICE_ID' &&
    templateId !== 'YOUR_TEMPLATE_ID' &&
    publicKey !== 'YOUR_PUBLIC_KEY' &&
    Boolean(serviceId && templateId && publicKey)
  );
}
